export const PRIMARY_ORANGE = '#F3A543';
export const PRIMARY_ORANGE_HOVER = '#BA5600';
